import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import chartPreview from './symbolTileChartPreview.png';
import valuesPreview from './symbolTileValuesPreview.png';

export const symbolTileDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Price Capsule details price movements of a selected symbol.
            </div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            title: 'Front',
            src: chartPreview,
            altText: 'symbol-capsule-chart-preview',
        },
        {
            title: 'Back',
            src: valuesPreview,
            altText: 'symbol-capsule-values-preview',
        },
    ],
};
